export const TILE_LAYER_CONFIG = {
    url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}.png',
    attribution:
        'Tiles © <a href="http://www.esri.com/" target="_blank">Esri</a>'
};

export const DEFAULT_CONFIG = {
    center: [-13.453737213419249, -55.06347656249999],
    zoom: 4,
    minZoom: 3,
    maxZoom: 17,
    doubleClickZoom: true,
    zoomControl: false,
    attributionControl: false,
    controles: {
        zoom: { enabled: true, position: 'topright' },
        fullscreen: { enabled: true, position: 'topright' },
        centralizar: { enabled: true, position: 'bottomright' },
        escala: { enabled: true, position: 'topright' }
    }
};

// Outras camadas de fundo: http://leaflet-extras.github.io/leaflet-providers/preview/
export const BASE_LAYERS_CONFIG = [
    {
        nome: 'Satélite',
        url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}.png',
        attribution:
            'Tiles © <a href="http://www.esri.com/" target="_blank">Esri</a>',
        maxNativeZoom: 15,
        maxZoomLevel: 17,
        urlImagem: 'basemap_satellite.png'
    },
    {
        nome: 'Topomap',
        url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer/tile/{z}/{y}/{x}',
        attribution:
            'Tiles &copy; Esri &mdash; Esri, DeLorme, NAVTEQ, TomTom, Intermap, iPC, USGS, FAO, NPS, ' +
            'NRCAN, GeoBase, Kadaster NL, Ordnance Survey, Esri Japan, METI, Esri China (Hong Kong), and the GIS User Community',
        maxNativeZoom: 17,
        maxZoomLevel: 17,
        urlImagem: 'basemap_topomap.png'
    },
    {
        nome: 'Google',
        url: 'http://www.google.com/maps/vt?lyrs=s@189&gl=cn&x={x}&y={y}&z={z}',
        attribution:
            'Map data © <a href="http://maps.google.com">Google</a> contributors',
        maxNativeZoom: 19,
        maxZoomLevel: 19,
        urlImagem: 'basemap_google.png'
    }
];

export const URL_GEOSERVER = `${location.origin}${process.env.VUE_APP_HTTP_PATH}/camadas/wms`;
export const URL_WMS_SENTINEL = `${location.origin}${process.env.VUE_APP_HTTP_PATH}/camadas/sentinel/wms`;

export const URL_KML_DOWNLOAD = {
    url: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/ows?service=WFS&version=1.0.0&request=GetFeature&typeName',
    output: 'outputFormat=application/vnd.google-earth.kml+xml'
};

export const DEFAULT_CONFIG_PARAGUAY = {
    center: [-23.447949, -58.452454],
    zoom: 6,
    minZoom: 3,
    maxZoom: 17,
    doubleClickZoom: true,
    zoomControl: false,
    attributionControl: false,
    controles: {
        zoom: { enabled: true, position: 'topright' },
        fullscreen: { enabled: true, position: 'topright' },
        centralizar: { enabled: true, position: 'bottomright' },
        escala: { enabled: true, position: 'topright' }
    }
};

export const DEFAULT_CONFIG_ARGENTINA = {
    center: [-34.996496, -64.967281],
    zoom: 5,
    minZoom: 3,
    maxZoom: 17,
    doubleClickZoom: true,
    zoomControl: false,
    attributionControl: false,
    controles: {
        zoom: { enabled: true, position: 'topright' },
        fullscreen: { enabled: true, position: 'topright' },
        centralizar: { enabled: true, position: 'bottomright' },
        escala: { enabled: true, position: 'topright' }
    }
};
